import { themeUi } from '../../themeUi/themeUi';

const usageReport = {
  sectionTitle: {
    color: themeUi.semantic.color.text.neutral800,
    spanColor: themeUi.semantic.color.text.neutral700,
    beforeColor: themeUi.semantic.color.text.neutral800
  },
  label: {
    color: themeUi.semantic.color.text.neutral800
  }
};

export default usageReport;
